import { OrgPrefName, useOrgPrefString } from 'src/hooks/api/org';

export const FALLBACK_AI_AGENT_LABEL = 'Agent';

export function useAiAgentMentionLabel() {
  const [aiAgentNamePref] = useOrgPrefString(OrgPrefName.STR_AI_AGENT_NAME, '');
  const aiAgentName = aiAgentNamePref?.trim();

  return aiAgentName || FALLBACK_AI_AGENT_LABEL;
}

export function useAiAgentLabel() {
  const aiAgentName = useAiAgentMentionLabel();

  return aiAgentName ? `${aiAgentName} (Agent)` : FALLBACK_AI_AGENT_LABEL;
}
